import {Card,} from 'react-bootstrap';

export default function PrivacyTOS() {
  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";
  return (
    <div style={{ marginTop: '5%', marginBottom: '7%',}}>
       <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1,
            }}
             >
            <source src={`${CF_BASE}/public/backgroundgrey2.mp4`} />
                Your browser does not support the video tag.
       </video>

      <div className='container'> 
     
      <div className='row align-items-center about-page-content'>
        <div className='d-flex justify-content-center about-us-header'>
        <h1> PRIVACY POLICY </h1>
        </div>
        <br></br>
        <div>
          <Card> 
        <div>
          <div className='col-12'> 
          <div> 
          <Card className="card-body" 
          style={{
            padding:'5%',
            marginBottom:'10%'}}>
              <Card.Text>
                <div className='d-flex justify-content-center'>
        
                </div>

                <Card.Text>
                Last Updated: December 1, 2025
                </Card.Text>

                <h2>
                  Summary
                </h2>
                <Card.Text>
                  At Brass Knuckle Films, we value your privacy. We collect information like your name, 
                email, and contest submissions to run our website, mobile app, and contests. We use 
                this information to manage contests, improve our services, and communicate with you. 
                We may share your information with trusted partners or as required by law. You have 
                rights to access, correct, or delete your information. Read below for full details.
                </Card.Text>

                <h2>
                  Introduction
                </h2>
                <Card.Text>
                RR Action LLC dba Brass Knuckle Films ("Brass Knuckle Films," "we," "our," or "us") is 
                committed to protecting your privacy. This Privacy Policy explains how we collect, use, 
                disclose, and safeguard your information when you interact with our website, mobile 
                application, or other online services (collectively, the "Services"), participate in our 
                contests, or otherwise engage with Brass Knuckle Films.

                By using our Services or participating in our contests, you acknowledge that you have read, 
                understood, and agree to be bound by this Privacy Policy. If you do not agree with our policies, 
                please do not use our Services or participate in our contests.
                </Card.Text>

                
                  <h2>
                    Information We Collect 
                  </h2>
                <Card.Text>
                  We collect various types of information from users of our Services and contest participants, including:
                </Card.Text> 
                  <h3>
                    Personal Information
                  </h3>
                  <div className="no-bullets" 
                  style={{
                    marginLeft: '5%',
                  }}
                  >
                  <li>
                  • Contact Information: Name, email address, mailing address
                  </li>
                  <li>
                  •	Identity Information: Date of birth, government-issued identification (for verification purposes)
                  </li>
                  <li>
                  •	Financial Information: Payment details, investment information (processed through Republic.com’s investment platform)
                  </li>
                  <li>
                  •	Professional Information: Background, experience, portfolio links
                  </li>
                  <li>
                  •	Contest Submissions: Ideas, concepts, scripts, videos, and other creative content submitted through our contests
                  </li>
                   <li>
                  •	Communication Records: Records of your communications with us
                  </li>
                  </div>
                    <h3>
                    Automatically Collected Information
                  </h3>
                  <div className="no-bullets" 
                  style={{
                    marginLeft: '5%',
                  }}
                  >
                  <li>
                   • Technical Information: IP address, browser type, operating system, device information
                  </li>
                  <li>
                  •	Usage Information: Pages visited, time spent on pages, links clicked, actions taken
                  </li>
                  <li>
                  •	Location Information: General location derived from IP address
                  </li>
                  <li>
                  •	Cookies and Tracking Technologies: We do not currently use cookies or similar tracking technologies. If we implement these in the future, our policy is outlined below.
                  </li>
                  </div>

                   <h3>
                    Future Use of Cookies and Tracking Technologies
                  </h3>
                  <Card.Text>
                    While we do not currently use cookies or similar tracking technologies, we may do so in the future to enhance your experience with our Services. If implemented, we will:
                  </Card.Text>
                  <div className="no-bullets" 
                  style={{
                    marginLeft: '5%',
                  }}
                  >
                  <li>
                   • Provide clear notice through a cookie consent banner on our website, if applicable
                  </li>
                  <li>
                  •	Obtain your consent for non-essential cookies as required by applicable law (e.g., GDPR, PIPEDA)
                  </li>
                  <li>
                  •	Allow you to manage cookie preferences through the consent banner or your browser settings
                  </li>
                  <li>
                  •	Use cookies for purposes such as analytics, improving website functionality, and personalizing content
                  </li>
                   <li>
                  •	Ensure that any data collected via cookies is protected in accordance with this Privacy Policy
                  </li>
                  </div>
                  <br></br>

                  <Card.Text>
                    You will be able to opt out of non-essential cookies, though this may affect your experience with our 
                    Services. We will update this Privacy Policy to reflect any future use of cookies or tracking technologies
                  </Card.Text>
           
                <h2>
                  How We Collect Your Information
                </h2>
                <Card.Text>
                  We collect information through:
                </Card.Text>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}>
                  <li>
                    •	Direct Interactions: Information you provide when registering, filling out forms, submitting contest entries, or communicating with us
                  </li>
  
                  <li>
                  •	Automated Technologies: Information collected automatically, such as IP address and usage data, when you visit our website
                  </li>

                  <li>
                  •	Third Parties: Information from business partners, service providers, or other third parties, such as Republic.com’s investment platform
                  </li>
                </div>


                <h2>
                  How We Use Your Information
                </h2>
                <Card.Text>
                 We use your information for various purposes, including:
                </Card.Text>
                 <h3>
                  Business Operations
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Processing and evaluating contest submissions
                </li>
                <li>
                  •	Managing investor relations and communications
                </li>
                <li>
                  •	Developing and producing films and other content based on winning concepts
                </li>
                <li>
                  •	Providing, maintaining, and improving our Services
                </li>
                <li>
                  •	Responding to inquiries and providing customer support
                </li>
                <li>
                  •	Sending administrative information, such as updates to our terms and policies
                </li>
                </div>



                <h3>
                  Marketing and Communication
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Sending you information about our productions, events, and opportunities
                </li>
                <li>
                  •	Delivering newsletters, promotional materials, and other communications
                </li>
                <li>
                  •	Conducting surveys and gathering feedback
                </li>
                </div>

                <h3>
                  Legal and Security
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Complying with applicable data protection laws, such as the General Data Protection Regulation (GDPR) for users in the European Economic Area, the California Consumer Privacy Act (CCPA) for California residents, Canada’s Personal Information Protection and Electronic Documents Act (PIPEDA) for Canadian residents, the Texas Data Privacy and Security Act (TDPSA) for Texas residents, and other relevant regulations
                </li>
                <li>
                  •	Enforcing our terms and policies
                </li>
                <li>
                  •	Protecting our rights, privacy, safety, or property, and that of our affiliates, you, or others
                </li>
                <li>
                  •	Preventing fraud and other prohibited or illegal activities
                </li>
                </div>

                <h2>
                  Disclosure of Your Information
                </h2>
                <Card.Text>
                 We may share your personal information with:
                </Card.Text>
                <h3>
                  Service Providers
                </h3>
              <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Contractors, service providers, and third parties who perform services on our behalf, including:
                </li>
                <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o		Enforcing our terms and policies
                </li>
                <li>
                  o		Protecting our rights, privacy, safety, or property, and that of our affiliates, you, or others
                </li>
                <li>
                  o		Preventing fraud and other prohibited or illegal activities
                </li>
                </div>
                </div>

                  <h3>
                  Business Partners
                </h3>
                  <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Production partners, distributors, and other business partners for the development, production, and distribution of our films, content, or products
                </li>
                </div>

                <h3>
                  Legal Requirements
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	To comply with court orders, laws, or legal processes
                </li>
                <li>
                  •	To respond to requests from public and government authorities
                </li>
                <li>
                  •	To enforce our terms and policies
                </li>
                <li>
                  •	To protect our rights, privacy, safety, or property, and that of our affiliates, you, or others
                </li>
                </div>

                <h3>
                  Business Transfers
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	In connection with any merger, sale of company assets, financing, or acquisition of all or a portion of our business
                </li>
                </div>

                <h3>
                  With Your Consent
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	For any other purpose with your explicit consent
                </li>
                </div>
                  
                  <br></br>
                <h2>
                  Contest Submissions and Creative Content
                </h2>
                <h3>
                  Special Provisions for Contests
                </h3>
                <Card.Text>
                  When you submit ideas, concepts, videos, or other creative content to our contests
                </Card.Text>

                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Submissions are reviewed by our judging panel and executives
                </li>
                <li>
                  •	Winning submissions may be developed into films and publicly credited
                </li>
                <li>
                  •	Non-winning submissions remain private and will not be used without your permission
                </li>
                <li>
                  •	All submissions are subject to contest rules, terms, and submission release agreements
                </li>
                </div>

                <h3>
                  Intellectual Property
                </h3>
                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Submitting content does not transfer intellectual property rights except 
                  as specified in the contest rules and submission release agreement. Non-winning 
                  submissions remain your property, and we will not use them without your explicit 
                  permission.
                </li>
                <li>
                  •	If your submission is selected as a winner, additional agreements will 
                  govern the use and ownership of your creative content.
                </li>
                </div>

                <br></br>

                <h2>
                  Your Choices and Rights
                </h2>
                <Card.Text>
                  Depending on your location, you may have rights regarding your personal information, including:
                </Card.Text>
                    <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Access: Request access to your personal information we hold
                </li>
                <li>
                  •	Correction: Request correction of inaccurate personal information
                </li>
                <li>
                  •	Deletion: Request deletion of your personal information in certain circumstances
                </li>
                <li>
                  •	Objection: Object to our processing of your personal information
                </li>
                 <li>
                  •	Withdrawal of Consent: Withdraw consent where processing is based on your consent
                </li>
                <li>
                  •	Data Portability: Request transfer of your personal information in a portable, easy-to-use format
                </li>
                <li>
                  •	Marketing Communications: Opt out of newsletters or promotional materials by clicking the "unsubscribe" link in our emails or contacting us at privacy@brassknucklefilms.com
                </li>
                  <li>
                  •	Future Cookies and Tracking Technologies: If we implement cookies in the future, you will be able to manage preferences through our cookie consent banner or your browser settings, as described above.
                </li>
                </div>

                <br></br>

                <Card.Text>
                  Residents of certain regions, including California, Texas, the European Economic Area, the United Kingdom, Switzerland, and Canada, have additional privacy rights as detailed below.
                </Card.Text>

                <br></br>

                <Card.Text>
                  To exercise these rights, contact us at privacy@brassknucklefilms.com.
                </Card.Text>

                <h3>
                  Additional Rights for California Residents
                </h3>
                <Card.Text>
                  Under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA), California residents have specific rights:
                </Card.Text>
                    <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Right to Know Categories and Sources: You can request detailed information about:
                </li>
              
                    <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o	Categories of personal information we collect about you
                </li>
                <li>
                  o	Sources from which we collect your personal information
                </li>
                <li>
                  o	Business or commercial purposes for collecting your personal information
                </li>
                <li>
                  o	Categories of third parties with whom we share your personal information
                </li>
                </div>
                </div>

              <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Right to Opt-Out: You have the right to opt-out of:
                </li>
              
                    <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o	Sale of your personal information (we do not sell personal information)
                </li>
                <li>
                  o	Sharing of your personal information for cross-context behavioral advertising
                </li>
                <li>
                  o	Use of sensitive personal information beyond what is necessary to provide our services
                </li>
                </div>
                </div>

                  <div className="no-bullets" 
                  style={{
                    marginLeft: '5%',
                  }}
                  >
                  <li>
                  •	Right to Limit Use of Sensitive Personal Information: You can request that we limit our use of sensitive personal information to only what is necessary to perform our services.
                </li>

                  </div>
       

                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Right to Non-Discrimination: We will not discriminate against you for exercising any of your CCPA/CPRA rights, including by:
                </li>
              
                    <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o	Denying goods or services
                </li>
                <li>
                  o	Charging different prices or rates
                </li>
                <li>
                  o	Providing different levels of quality
                </li>
                 <li>
                  o	Suggesting you will receive different prices or quality
                </li>
                </div>
                </div>

                <br></br>

                <Card.Text>
                  How to Exercise California Rights: Submit requests by emailing 
                  privacy@brassknucklefilms.com with "California Privacy Request" 
                  in the subject line. We will verify your identity and respond within 
                  45 days (extendable by an additional 45 days if needed).
                </Card.Text>

                <h3>
                  Additional Rights for Texas Residents
                </h3>

                 <Card.Text>
                  Under the Texas Data Privacy and Security Act (TDPSA), effective July 1, 2024, 
                  Texas residents have rights including:
                </Card.Text>

                 <li className="no-bullets" >
                  •	Right to Confirm and Access: Confirm whether we process your personal data and access your personal data
                </li>
                 <li className="no-bullets" >
                  •	Right to Correct: Request correction of inaccurate personal data
                </li>
                 <li className="no-bullets" >
                  •	Right to Delete: Request deletion of personal data provided by or obtained about you
                </li>
                 <li className="no-bullets" >
                  •	Right to Data Portability: Obtain a copy of your personal data in a portable, easy-to-use format
                </li>


                <div className="no-bullets">
                <li>
                  •	Right to Opt-Out: Opt-out of:
                </li>
              
                    <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o	Processing for targeted advertising
                </li>
                <li>
                  o	Sale of personal data (we do not sell personal data)
                </li>
                <li>
                  o	Profiling that produces legal or similarly significant effects through automated decision-making
                </li>
                </div>
                </div>

                <br></br>

                <Card.Text>
                  How to Exercise Texas Rights: Submit requests by emailing privacy@brassknucklefilms.com with "Texas Privacy Request" in the subject line. We will respond within 45 days and will not charge a fee for processing your request unless it is excessive or repetitive.
                </Card.Text>

                <h2>
                  Data Security
                </h2>

                <Card.Text>
                  We use reasonable security measures to protect your personal information from loss, misuse, unauthorized access, disclosure, alteration, and destruction. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
                </Card.Text>

                <h2>
                  Data Breach Notification
                </h2>

                <Card.Text>
                  In the event of a data security incident that affects your personal information, we are committed to transparent and timely communication.
                </Card.Text>

                <h3>
                  What Constitutes a Reportable Breach
                </h3>

                <Card.Text>
                  We will notify you if there is unauthorized access to, acquisition of, or disclosure of your personal information that compromises the security, confidentiality, or integrity of your personal information.
                </Card.Text>

                <h3>
                  Notification Timeline
                </h3>

                  <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	We will notify affected individuals without unreasonable delay, in accordance with applicable laws (e.g., within 72 hours of discovery for GDPR and PIPEDA requirements, or as required by CCPA and TDPSA).
                </li>
                <li>
                  •	We will also notify relevant regulatory authorities as required by law.
                </li>
                </div>

                <h3>
                  How We Will Notify You
                </h3>

                 <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Primary Method: Email notification sent to the email address associated with your account
                </li>
                <li>
                  •	Alternative Methods: If email is unavailable or insufficient, we may use:
                </li>
                   <div
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  o	Prominent notice on our website homepage
                </li>
                <li>
                  o	Direct mail to your last known address
                </li>
                <li>
                  o	Other communication methods as required by applicable law
                </li>
                </div>
                </div>

                <h3>
                  Information We Will Provide
                </h3>

                <Card.Text>
                  Our breach notification will include:
                </Card.Text>

                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Description of what happened and when we discovered it
                </li>
                <li>
                  •	Types of personal information that were involved
                </li>
                 <li>
                  •	Steps we have taken to address the breach and protect your information
                </li>
                <li>
                  •	What you can do to protect yourself
                </li>
                 <li>
                  •	How to contact us for more information
                </li>
                <li>
                  •	Resources for identity protection services, if applicable
                </li>
                </div>

                <h3>
                  What We Do Immediately
                </h3>

                <Card.Text>
                  Upon discovering a breach, we will:
                </Card.Text>

                <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Contain the incident and assess the scope
                </li>
                <li>
                  •	Investigate the cause and implement fixes
                </li>
                 <li>
                  •	Coordinate with law enforcement if criminal activity is suspected
                </li>
                <li>
                  •	Document the incident and our response for regulatory compliance
                </li>
                 <li>
                  •	Review and update our security measures to prevent similar incidents
                </li>
                </div>

                <h3>
                  Your Role
                </h3>

                <Card.Text>
                  If you suspect unauthorized access to your account or notice suspicious activity, please contact us immediately at privacy@brassknucklefilms.com.
                </Card.Text>

                <h2>
                  Data Retention
                </h2>

                <Card.Text>
                  We retain your personal information only as long as necessary to fulfill the purposes for which it was collected, including to meet legal, accounting, or reporting requirements. For example, personal information collected for account management or customer support is typically retained for up to five years after your last interaction with us to comply with tax, legal, and business record-keeping obligations, unless a longer period is required by law.
                </Card.Text>

                <h3>
                  Contest Submissions
                </h3>

                   <div className="no-bullets" 
                 style={{
                    marginLeft: '5%',
                  }}
                >
                <li>
                  •	Non-winning contest submissions are retained for up to one year after the contest concludes
                </li>
                <li>
                  •	Winning contest submissions are retained for the duration of the development, production, and exploitation processes and as long as necessary for legal and business purposes
                </li>
                </div>

                <h2>
                  International Data Transfers
                </h2>

                <Card.Text>
                  Brass Knuckle Films is based in the United States. If you access our Services from outside the United States, your information may be sent to, stored, and processed in the United States or other countries. We ensure that any transfer of your personal information complies with applicable data protection laws, such as using standard contractual clauses for transfers to countries without adequate data protection standards.
                </Card.Text>

                <br></br>

                <Card.Text>
                  For users in the European Economic Area (EEA), United Kingdom, Switzerland, or Canada, we implement appropriate safeguards as required by data protection laws, including GDPR and PIPEDA, for transfers outside these regions.
                </Card.Text>

                <h2>
                  Children's Privacy
                </h2>

                <Card.Text>
                  Our Services are not intended for individuals under 18. We do not knowingly collect personal information from children under 18. If we learn we have collected such information, we will delete it. If you believe we have information from a child under 18, contact us at privacy@brassknucklefilms.com.
                </Card.Text>

                <h2>
                  Third-Party Websites and Services
                </h2>

                <Card.Text>
                  Our Services may link to third-party websites and services, such as Republic.com’s investment platform. We are not responsible for the privacy practices or content of these third parties. We encourage you to review their privacy policies before providing any information.
                </Card.Text>

                <h2>
                  Changes to Our Privacy Policy
                </h2>

                <Card.Text>
                  We may update this Privacy Policy from time to time. If we make significant changes, we will notify you by email or through a notice on our website before the changes take effect. Your continued use of our Services after these changes means you accept the updated policy.
                </Card.Text>

                <h2>
                  Contact Information
                </h2>

                <Card.Text>
                  If you have questions or concerns about this Privacy Policy or our privacy practices, contact us at:
                </Card.Text>

                <br></br>

                <Card.Text>
                  RR Action LLC dba Brass Knuckle Films
                </Card.Text>
                <Card.Text>
                  4900 Old Manor Rd
                </Card.Text>
                <Card.Text>
                  Austin, TX 78723
                </Card.Text>
                <Card.Text>
                  privacy@brassknucklefilms.com 
                </Card.Text>

                <br></br>

                <Card.Text>
                  © 2025 RR Action LLC dba Brass Knuckle Films. All rights reserved.
                </Card.Text>






              </Card.Text>
              </Card>

          
            </div>
            </div>
            </div>
            </Card>
            </div>
        </div>
        
      </div>
    </div>
  );
}
